import type { MessageState } from '#nora-chat-ui/states';

export interface MessageListMarkers {
  /** Messages that start a new calendar day and get a date separator above them. */
  dayStartMessageIds: Set<string>;
  lastSentMessageId?: string;
  lastReceivedMessageId?: string;
  /** Your latest message the other person has read. */
  lastSeenSentMessageId?: string;
}

function getDayKey(date: Date): string {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

/**
 * Derives the per-message markers of a conversation in a single pass, so each
 * rendered message doesn't have to scan the whole message list itself.
 */
export function getMessageListMarkers(
  messages: readonly MessageState[],
  userId: string | undefined,
): MessageListMarkers {
  const markers: MessageListMarkers = {
    dayStartMessageIds: new Set(),
  };

  let previousDayKey: string | undefined;

  for (const { message } of messages) {
    const dayKey = getDayKey(new Date(message.createdAt));

    if (dayKey !== previousDayKey) {
      markers.dayStartMessageIds.add(message.id);
      previousDayKey = dayKey;
    }

    if (message.sentBy.id === userId) {
      markers.lastSentMessageId = message.id;

      if ((message.readMessagesCount ?? 0) > 0) {
        markers.lastSeenSentMessageId = message.id;
      }
    }
    else {
      markers.lastReceivedMessageId = message.id;
    }
  }

  return markers;
}
